import { supabase } from './supabaseClient'

const failure = code => Object.assign(new Error(code),{code})
const PUBLICATION_PATH = /^\/api\/v1\/publications\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/pdf$/i

// The service may return only the official PDF endpoint. No redirect supplied by
// a profile, a query string, or another publication host is ever navigated to.
export function ownRegistryDocumentUrl(value) {
  if (typeof value !== 'string' || value.length > 200) return null
  try {
    const url = new URL(value)
    if (url.protocol === 'https:' && url.hostname === 'amtsblattportal.ch' && !url.port &&
        !url.username && !url.password && !url.search && !url.hash && PUBLICATION_PATH.test(url.pathname)) return url.href
  } catch {}
  return null
}

// The server determines the company from this authenticated user's session.
// No company identifier or UID from the browser is sent in the request body.
export async function readOwnRegistryDocument({expectedUserId,signal,client = supabase} = {}) {
  if (!expectedUserId) throw failure('auth_changed')
  const controller = new AbortController()
  let timer,onAbort
  const deadline = new Promise((_,reject) => {
    onAbort = () => {controller.abort();reject(failure('aborted'))}
    signal?.addEventListener('abort',onAbort,{once:true})
    if (signal?.aborted) onAbort()
    timer = window.setTimeout(() => {controller.abort();reject(failure('timeout'))},15000)
  })
  const currentSession = async () => {
    if (controller.signal.aborted) throw failure('aborted')
    const {data,error} = await client.auth.getSession()
    if (controller.signal.aborted) throw failure('aborted')
    const session = data?.session
    if (error || session?.user?.id !== expectedUserId || !session?.access_token) throw failure('auth_changed')
    return session
  }
  const work = Promise.resolve().then(async () => {
    const session = await currentSession()
    const result = await client.functions.invoke('registry-own-document',{
      body:{},headers:{Authorization:`Bearer ${session.access_token}`},signal:controller.signal,
    })
    if (controller.signal.aborted) throw failure('aborted')
    if (result.error || result.data?.ok !== true) throw failure('unavailable')
    const url = ownRegistryDocumentUrl(result.data.url)
    const publishedAt = result.data.publishedAt
    if (!url || typeof publishedAt !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(publishedAt) ||
        (!Number.isFinite(new Date(`${publishedAt}T12:00:00Z`).getTime()) || new Date(`${publishedAt}T12:00:00Z`).toISOString().slice(0,10) !== publishedAt)) throw failure('invalid_response')
    await currentSession()
    return {url,publishedAt}
  })
  try {return await Promise.race([work,deadline])}
  finally {window.clearTimeout(timer);signal?.removeEventListener('abort',onAbort)}
}
